import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const StreamingService = {
  // Recommendations
  async getRecommendations(limit = 20, includeReasoning = false) {
    const { data } = await axios.get(
      `${API_URL}/streaming/recommendations?limit=${limit}&include_reasoning=${includeReasoning}`
    );
    return data;
  },

  async getTrending(limit = 20) {
    const { data } = await axios.get(`${API_URL}/streaming/trending?limit=${limit}`);
    return data;
  },

  async getSimilarVideos(videoId, limit = 10) {
    const { data } = await axios.get(`${API_URL}/streaming/similar/${videoId}?limit=${limit}`);
    return data;
  },

  async explainRecommendation(videoId) {
    const { data } = await axios.get(`${API_URL}/streaming/explain/${videoId}`);
    return data;
  },

  // User actions
  async rateVideo(videoId, rating) {
    const { data } = await axios.post(`${API_URL}/streaming/rate/${videoId}?rating=${rating}`);
    return data;
  },

  async addToWatchlist(videoId) {
    const { data } = await axios.post(`${API_URL}/streaming/watchlist/${videoId}`);
    return data;
  },

  async removeFromWatchlist(videoId) {
    const { data } = await axios.delete(`${API_URL}/streaming/watchlist/${videoId}`);
    return data;
  },

  async addFavorite(videoId) {
    const { data } = await axios.post(`${API_URL}/streaming/favorite/${videoId}`);
    return data;
  },

  async recordWatchProgress(videoId, progress, completed = false) {
    const { data } = await axios.post(
      `${API_URL}/streaming/watch-progress/${videoId}`,
      { progress, completed }
    );
    return data;
  },

  // Profile
  async getProfile() {
    const { data } = await axios.get(`${API_URL}/streaming/profile`);
    return data;
  }
};